import { Component, OnInit, OnDestroy, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { Subscription , of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { GridApi } from 'ag-grid';
import { ActivatedRoute } from '@angular/router';

import { Constants } from '@utils/constants';
import { AbstractItem } from '@business/base/abstract-item';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { Box } from '@business/home/workspace-new/workspace-new.component';
import { OrdersHistoryPresenter } from '@business/orders-history/orders-history.presenter';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { DailyOrderService } from '@services/webFeeder/sckt-daily-order.service';
import { ConfigService } from '@services/webFeeder/config.service';
import { AuthServer } from '@services/auth-server.service';

@Component({
  selector: Constants.WINDOW_NAME_ORDER_WKS,
  templateUrl: './order-wks.component.html'
})
export class OrderWksComponent extends AbstractItem implements OnInit, OnDestroy {

  @Input() override data: Box;
  @ViewChild('orderwkscomponent', { read: ViewContainerRef }) parent: ViewContainerRef;

  private gridApiOrders: GridApi;
  private subscriptions: Array<Subscription> = [];
  private auxSubscriptions: Array<Subscription> = [];
  private historyOrderPresenter: OrdersHistoryPresenter = new OrdersHistoryPresenter();

  title = Constants.TITLE_CARD_ORDER_WKS;
  newWindow = false;
  windowActive: any;
  model = { symbol: '' };
  showExpandCard = this._configService.getShowExpandCard(Constants.WINDOW_NAME_ORDER_WKS);
  quantityOrderData = [];
  account: string;
  msgOfflineNegotiation = Constants.MSG_OFFLINE_NEGOTIATION_01;
  defaultColDef;
  showSelectors = false;
  loading: boolean;
  isFirstLoading = true;
  eletronicSignature = this._configService.getEletronicSignatureType();
  quantityOrder = {
    executed: 0,
    open: 0,
    refused: 0,
    total: 0
  };
  removeFromWksTooltip = Constants.TOOLTIP_REMOVE_WKS_TOOL;
  filterActiveLabel = '';
  filterDirectionLabel = '';
  filterStatusLabel = '';
  statusFilter = ['Aberta', 'Nova', 'Parcialmente Executada', 'Editada', 'Cancelamento Pendente', 'Pendente', 'Edição Pendente', 'Suspensa'];
  showStrategies = false;

  filters = {
    properties: [
      { field: 'buyOrSell', label: 'Direção' },
      { field: 'state', label: 'Status' }
    ],
    valuesSelected: {
      quote: 'Todos',
      buyOrSell: 'Todos',
      state: 'Todos',
    },
    values: {
      quote: [{ desc: 'Todos' }],
      buyOrSell: [
        { desc: 'Todos', dailyFilter: 'Todos' },
        { desc: 'Compra', dailyFilter: 'Compra' },
        { desc: 'Venda', dailyFilter: 'Venda' },
      ],
      state: [
        { desc: 'Todos', dailyFilter: 'Todos' },
        { desc: 'Abertas', dailyFilter: 'Aberta' },
        { desc: 'Executadas', dailyFilter: 'Executada' },
        { desc: 'Canceladas', dailyFilter: 'Cancelada' },
        { desc: 'Rejeitadas', dailyFilter: 'Rejeitada' },
        { desc: 'Expiradas', dailyFilter: 'Expirada' },
      ]
    },
    filterChange: null
  };

  get filtersDescription(): string {
    let description = '';
    if (this.filterActiveLabel) {
      description += `Ativo: ${this.filterActiveLabel}`;
    }

    if (this.filterDirectionLabel) {
      description += description && ' | ';
      description += `Direção: ${this.filterDirectionLabel}`;
    }

    if (this.filterStatusLabel) {
      description += description && ' | ';
      description += `Status: ${this.filterStatusLabel}`;
    }

    return description ? ` - ${description}` : '';
  }

  constructor(
    _dialog: MatDialog,
    _workspaceService: WorkspaceNewService,
    _itemService: AbstractItemService,
    private _configService: ConfigService,
    private _dailyOrderService: DailyOrderService,
    private _route: ActivatedRoute,
    private _authServer: AuthServer
  ) {
    super(_workspaceService, _dialog, _itemService);
    this.workspaceService = _workspaceService;
  }

  ngOnInit() {
    this.loading = true;
    this._route.queryParams.subscribe(params => {
      if (params['account']) {
        this.account = params['account'];
        this.newWindow = true;
      }
    });
    if (this.newWindow) {
      setTimeout(() => {
        if (this.isFirstLoading) {
          this.getStrategies();
        }
      }, 50);
    } else {
      this.auxSubscriptions.push(
        this._configService.authHbLogged$.subscribe(loggedNegotiation => {
          if (loggedNegotiation) {
            this.account = this._configService.getBrokerAccountSelected();
          } else {
            if (this.account) {
              this.account = null;
              this._dailyOrderService.unsubscribeDailyOrder(this.account, Constants.WINDOW_NAME_ORDER_WKS);
              this.subscriptions.forEach(subscription => subscription.unsubscribe());
            }
          }
          if (this.isFirstLoading) {
            this.getStrategies();
          }
        }));

      this.auxSubscriptions.push(
        this._configService.changeAccountBillet$.subscribe(account => {
          if (account && account.toString() !== this.account) {
            this._dailyOrderService.unsubscribeDailyOrder(this.account, Constants.WINDOW_NAME_ORDER_WKS);
            this.subscriptions.forEach(subscription => subscription.unsubscribe());
            this.account = account;
            this.gridApiOrders.setRowData([]);
            this.subscribeOrders();
          }
        }));
    }
  }

  getStrategies() {
    this.loading = true;
    this._authServer.iNegotiation.getStrategies()
      .subscribe(res => {
        if (res && res.length > 1) {
          this.showStrategies = true;
        } else {
          this.showStrategies = false;
        }
        this.isFirstLoading = false;
        this.loading = false;
      }, () => {
        this.isFirstLoading = true;
      });
  }

  checkForBlank(value) {
    if (value === '') {
      this.filters.valuesSelected.quote = 'Todos';
      this.gridApiOrders.onFilterChanged();
      this.filterActiveLabel = '';

    } else if (value.length > 3) {
      this.filters.valuesSelected.quote = value.toUpperCase();
      this.filterActiveLabel = value.toUpperCase();
      this.gridApiOrders.onFilterChanged();
    }
  }

  selectAsset(value) {
    if (value.symbol !== '') {
      this.filters.valuesSelected.quote = value.symbol.toUpperCase();
      this.gridApiOrders.onFilterChanged();
    } else {
      this.filters.valuesSelected.quote = 'Todos';
      this.gridApiOrders.onFilterChanged();
      this.filterActiveLabel = '';
    }

  }

  onGridReady(params) {
    this.loading = false;
    this.gridApiOrders = params.api;
    this.subscribeOrders();
  }

  subscribeOrders() {
    if (this.account) {
      this.subscriptions.push(this._dailyOrderService.subscribeDailyOrder(this.account, Constants.WINDOW_NAME_ORDER_WKS).subscribe(
        data => {
          if (data && data.length > 0) {
            this.updateOrders(data);
          }
        }
      ));
    }
    this.subscriptions.push(
      this._dailyOrderService.messagesDailyOrder
        .subscribe(res => {
          this.updateOrders(res);
        })
    );
  }

  updateOrders(response) {
    if (!this.gridApiOrders) {
      return;
    }

    const dataLength = this.gridApiOrders.getDisplayedRowCount();
    const presenterOrders = [...this.historyOrderPresenter.transformDailyOrder(response)];
    if (presenterOrders.length) {
      this.calculateQuantityOrders(presenterOrders);
    }
    if (dataLength === 0) {
      this.setFilters(presenterOrders);
      this.gridApiOrders.setRowData(presenterOrders);
    } else {
      presenterOrders.forEach(order => {
        const renderedNodes = this.gridApiOrders.getRenderedNodes();
        const orderToEdit = renderedNodes.findIndex(item => item.id === order['orderID']);
        if (orderToEdit !== undefined && orderToEdit !== -1) {
          this.gridApiOrders.updateRowData({ update: [order] });
          this.gridApiOrders.refreshCells({ columns: ['actions'], force: true });
        } else {
          this.gridApiOrders.updateRowData({ add: [order], addIndex: (this.gridApiOrders.getDisplayedRowCount()) });
        }
      });
    }
  }

  ngOnDestroy() {
    this._dailyOrderService.unsubscribeDailyOrder(this.account, Constants.WINDOW_NAME_ORDER_WKS);
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.auxSubscriptions.forEach(subscription => subscription.unsubscribe());
    this.closeSheet();
  }

  openNewWindow() {
    const options = 'width=600px, height=300px';
    const parameters = '?account=' + this.account;
    if (this.windowActive == null || this.windowActive.closed) {
      super.getNewWindow(Constants.WINDOW_NAME_ORDER_WKS, parameters, options, this.data.id)
        .subscribe(window => {
          this.windowActive = window;
        });
    } else {
      this.windowActive.focus();
    }
  }

  closeSheet() {
    if (this.windowActive != null) {
      this.windowActive.close();
    }
  }

  setFilters(orders) {
    orders.forEach(element => {
      const quote = element.quote;
      if (!this.filters.values.quote.find(x => x == quote)) {
        this.filters.values.quote.push(quote);
      }
    });
  }

  applyFilter(item, filter) {
    if (filter === 'buyOrSell') {
      this.filterDirectionLabel = item !== 'Todos' ? item : '';
    }

    if (filter === 'state') {
      this.filterStatusLabel = item !== 'Todos' ? item : '';
    }

    this.filters.filterChange = filter;
    this.gridApiOrders.onFilterChanged();
  }

  toggleDisplaySelectors() {
    this.showSelectors = !this.showSelectors;
  }

  calculateQuantityOrders(orders) {
    if (this.quantityOrderData.length) {
      orders.forEach(element => {
        const ordersData = this.quantityOrderData.find(item => element.orderID === item.orderID);
        if (!ordersData) {
          this.quantityOrderData.push(element);
        } else {
          const indexData = this.quantityOrderData.indexOf(ordersData);
          this.quantityOrderData[indexData] = element;
        }
      });
    } else {
      this.quantityOrderData = orders;
    }
    this.quantityOrder.executed = this.quantityOrderData.filter(x => x.state === 'Executada').length;
    this.quantityOrder.open = this.quantityOrderData.filter(x => this.statusFilter.indexOf(x.state) > -1).length;
    this.quantityOrder.refused = this.quantityOrderData.filter(x => x.state === 'Rejeitada').length;
    this.quantityOrder.total = this.quantityOrderData.length;
    this.gridApiOrders.onFilterChanged();
  }
}
